import React, { memo, useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";
import { ISearchListProps } from "./SearchListProps";

import HotelCard from "../../HotelCard/HotelCard";
// import { Container } from "./SearchListHelpers";

const SearchList = ({
  hotels,
  search,
  isLoading,
  onClickHotelImage,
  onRateLoad,
  pageType,
  isPromoValid,
}: ISearchListProps) => {
  const hotelListRef = React.useRef();
  const [totalHotels, setTotalHotels] = useState(0);
  const showPriceFilterNoResultMsg = !!search.priceFilter;
  const [displayRedlionCard, setDisplayRedlionCard] = useState(false);

  const renderHotelList = () => {
    if (hotels.length) {
      return hotels.map((hotel: { crsHotelCode?: any }, i: number) => {
        return (
          <HotelCard
            key={hotel.crsHotelCode}
            hotel={hotel}
            stacked={false}
            onClickHotelImage={onClickHotelImage}
            positionInSearchResult={i + 1}
            onRateLoad={onRateLoad}
            isPromoValid={isPromoValid}
          />
        );
      });
    }
    return null;
  };

  useEffect(() => {
    let canceledRequest = false;
    !canceledRequest && setTotalHotels(-1);
    if (!isLoading) {
      const filteredHotels = Object.values(
        hotelListRef.current.childNodes
      ).filter((ele) => ele.classList.contains("no-price-filter"));
      !canceledRequest && setTotalHotels(filteredHotels.length);
    }

    return () => {
      canceledRequest = true;
    };
  }, [isLoading]);

  return (
    <Col>
      {isLoading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {totalHotels == 0 && showPriceFilterNoResultMsg && (
            <div className="text-center mb-5 pb-5">
              We did not find any Sonesta hotels within 50 miles of your search
              location. Please try another destination or visit Sonesta
              Locations for a full list of hotels.
            </div>
          )}
          <div ref={hotelListRef}>{renderHotelList()}</div>
        </>
      )}
    </Col>
  );
};
export default memo(SearchList);
